import { AdvancedTitle } from '../interfaces/advanced-title.interface';
import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class TitleConfigService {
  mainTitle: AdvancedTitle[] = [{ title: '' }];
  mainTitle$ = new Subject<AdvancedTitle[]>();

  subTitle: AdvancedTitle[] = [{ title: '' }];
  subTitle$ = new Subject<AdvancedTitle[]>();

  public setTitles(mainTitle: string | AdvancedTitle[], subTitle: string | AdvancedTitle[]): void {
    if ((typeof mainTitle).toLowerCase().includes('string')) {
      this.mainTitle = [{ title: mainTitle }] as AdvancedTitle[];
    } else {
      this.mainTitle = mainTitle as AdvancedTitle[];
    }

    if ((typeof subTitle).toLowerCase().includes('string')) {
      this.subTitle = [{ title: subTitle }] as AdvancedTitle[];
    } else {
      this.subTitle = subTitle as AdvancedTitle[];
    }

    this.mainTitle$.next(this.mainTitle);
    this.subTitle$.next(this.subTitle);
  }
}
